module.exports = __webpack_public_path__ + "img/about6.babaabe2.png";